export default __webpack_public_path__ + "84ea127206b87b4d9ffa994009fb6e25.svg";